import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { autoRehydrate } from 'redux-persist'

import rootReducer from './rootReducer'

export default function storeConfig () {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

  const store = createStore(
    rootReducer,
    composeEnhancers(
      applyMiddleware(thunk),
      autoRehydrate()
    )
  )

  return store
}



// WEBPACK FOOTER //
// ./src/store/storeConfig.js